(function () {
  function getCartSections(cartDrawer) {
    return cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map((section) => section.id)
      : ['cart-drawer', 'cart-icon-bubble'];
  }

  async function parseCartResponse(response) {
    const state = await response.json();
    if (!response.ok || state.status) {
      throw new Error(state.description || state.message || 'Der Warenkorb konnte nicht aktualisiert werden.');
    }
    return state;
  }

  function renderCartState(state, keepOpen) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state.sections) {
      cartDrawer.renderContents(state, keepOpen);
      return;
    }
    window.location.assign('/cart');
  }

  class SonneseeCartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', this.handleClick.bind(this));
    }

    async handleClick(event) {
      const button = event.target.closest('[data-cart-recommendation-add]');
      if (!button || button.disabled) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const error = this.querySelector('.ss-recommendations__error');
      const originalLabel = button.innerHTML;
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Wird hinzugefügt …';
      if (error) error.hidden = true;

      try {
        const sections = getCartSections(cartDrawer);
        const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: Number(button.dataset.cartRecommendationAdd),
            quantity: 1,
            sections,
            sections_url: window.location.pathname
          })
        });
        const state = await parseCartResponse(response);
        if (this.closest('[data-sonnesee-cart-page]')) {
          window.location.assign('/cart');
        } else {
          renderCartState(state, true);
        }
      } catch (exception) {
        button.classList.remove('is-loading');
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = originalLabel;
        if (error) {
          error.textContent = exception.message;
          error.hidden = false;
        }
      }
    }
  }

  if (!customElements.get('sonnesee-cart-recommendations')) {
    customElements.define('sonnesee-cart-recommendations', SonneseeCartRecommendations);
  }

  document.addEventListener('click', function (event) {
    const pointsButton = event.target.closest('[data-points-simulation]');
    if (!pointsButton) return;
    const note = pointsButton.closest('.ss-points')?.querySelector('.ss-points__note');
    if (note) note.hidden = !note.hidden;
  });
})();
